import { render, staticRenderFns } from "./CustomersOnetimeCorporateForm.vue?vue&type=template&id=480037e1&scoped=true"
import script from "./CustomersOnetimeCorporateForm.vue?vue&type=script&lang=js"
export * from "./CustomersOnetimeCorporateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480037e1",
  null
  
)

export default component.exports